export default "__VITE_ASSET__BEusfoAZ__"